import React from "react";
import Card from "./Card";
import parse from "html-react-parser";
import SecureImage from "components/UI/atoms/SecureImage";
import { getDefaultImageByType } from "./MainProductCard";

export const cleanMediaContent = (media = "") => {
  if (!media) return "";
  const iframeStart = media.indexOf("<iframe");
  if (iframeStart !== -1) {
    return media.substring(iframeStart);
  }
  return media;
};

const adjustIframeAttributes = (htmlContent, fixedHeight = "250") => {
  return htmlContent.replace(/<iframe([^>]*)>/gi, (match, attrs) => {
    let newAttrs = attrs;

    // Remove existing height/width/style attributes
    newAttrs = newAttrs.replace(/\sheight\s*=\s*["'][^"']*["']/i, "");
    newAttrs = newAttrs.replace(/\swidth\s*=\s*["'][^"']*["']/i, "");
    newAttrs = newAttrs.replace(/\sstyle\s*=\s*["'][^"']*["']/i, "");

    // Add new height, width and style attributes
    newAttrs += ` height="${fixedHeight}" width="100%" style="width:100%; height:${fixedHeight}; border:none;"`;

    return `<iframe${newAttrs}>`;
  });
};

const ImageCard = ({
  image,
  height,
  width,
  classes,
  type,
  imgAbsoluteContent,
  isEmbedded,
  title,
  ...rest
}) => {
  // Clean and adjust iframe attributes
  const adjustedImage =
    isEmbedded && image
      ? adjustIframeAttributes(cleanMediaContent(image), height)
      : image;

  return (
    <Card
      classes={`${classes} overflow-hidden overflowY-hidden px-0 py-0 relative`}
      width={width}
      height={height || "250px"}
    >
      {isEmbedded && image ? (
        <div className="w-full h-full relative" style={{ height }}>
          {/* Render the adjusted iframe */}
          {parse(adjustedImage)}
        </div>
      ) : (
        <SecureImage
          data-testid="image-card"
          src={image}
          placeholder={getDefaultImageByType(type)}
          alt={title}
          height="100%"
          width="100%"
          title={title ?? type}
          imgAbsoluteContent={imgAbsoluteContent}
          {...rest}
        />
      )}
    </Card>
  );
};

export default ImageCard;
